export function PlayIcon({ name }: { name: "arrow" | "back" | "flip" | "reset" | "focus" | "sound" | "muted" | "book" | "close" | "check" | "spark" | "download" | "menu" | "help" }) {
  const paths = {
    arrow: "M4 12h15m-6-6 6 6-6 6", back: "M20 12H5m6-6-6 6 6 6",
    flip: "M4 8h15l-4-4m5 12H5l4 4", reset: "M4 10a8 8 0 1 1 2 8M4 4v6h6",
    focus: "M8 3H3v5m13-5h5v5M3 16v5h5m8 0h5v-5",
    sound: "M11 4 6 8H3v8h3l5 4V4m4 4a6 6 0 0 1 0 8m3-11a10 10 0 0 1 0 14",
    muted: "M11 4 6 8H3v8h3l5 4V4m5 5 6 6m0-6-6 6",
    book: "M5 3h14v18l-7-5-7 5V3Z", close: "m6 6 12 12M6 18 18 6", check: "m4 12 5 5L20 6",
    spark: "m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5L12 3Z",
    download: "M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5",
    menu: "M4 6h16M4 12h16M4 18h16",
    help: "M9 9a3 3 0 1 1 5 2c-1.4.7-2 1.4-2 3m0 3h.01M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0",
  };
  return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[name]} /></svg>;
}
